import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { ToggleSwitch } from 'primeng/toggleswitch';
import { TooltipModule } from 'primeng/tooltip';

interface ToggleCellParams extends ICellRendererParams {
  canEdit: boolean;
  /** Fired with the row and the user's new value. */
  onToggle: (row: any, newValue: boolean) => void;
  /** Optional tooltip text shown when the toggle is on. */
  trueLabel?: string;
  /** Optional tooltip text shown when the toggle is off. */
  falseLabel?: string;
}

/** Generic ag-grid cell renderer for a boolean field rendered as a PrimeNG toggle switch. */
@Component({
  standalone: true,
  imports: [FormsModule, ToggleSwitch, TooltipModule],
  template: `
    <p-toggleswitch
      class="flex"
      [(ngModel)]="value"
      [disabled]="!canEdit"
      (ngModelChange)="emit($event)"
      [pTooltip]="tooltip"
      tooltipPosition="top"
    />
  `,
})
export class ToggleCellComponent implements ICellRendererAngularComp {
  value = false;
  canEdit = false;
  tooltip = '';
  private params!: ToggleCellParams;

  agInit(params: ToggleCellParams): void {
    this.params = params;
    this.value = !!params.value;
    this.canEdit = params.canEdit;
    this.tooltip = this.resolveTooltip();
  }
  refresh(params: ToggleCellParams): boolean {
    this.params = params;
    this.value = !!params.value;
    this.canEdit = params.canEdit;
    this.tooltip = this.resolveTooltip();
    return true;
  }
  emit(newValue: boolean): void {
    this.value = newValue;
    this.tooltip = this.resolveTooltip();
    this.params.onToggle?.(this.params.data, newValue);
  }
  private resolveTooltip(): string {
    return this.value
      ? (this.params.trueLabel ?? '')
      : (this.params.falseLabel ?? '');
  }
}
